import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { connect, useDispatch, useSelector } from "react-redux";
import ContentContainer from "../../common/ContentContainer";
import { useTranslation } from "react-i18next";
import { Col, Form, Row } from "react-bootstrap";
import { CREATE_BOT_START, SET_BOT_NAME } from "../../../actions/create-bot-type";
import BotTitle from "./modules/BotTitle";
import AssetParamSection from "./modules/AssetParamSection";
import EntryExitSection from "./modules/EntryExitSection";
import BackTestSection from "./modules/BackTestSection";
import { useHistory, useLocation } from "react-router-dom";
import IndicatorSetting from "./indicator-setting/IndicatorSetting";
import IndicatorSettingModal from "./indicator-setting/IndicatorSettingModal";
import CreateBotSection from "./modules/CreateBotSection";
import Loading from "../../common/Loading";
import AssetView from "./AssetView";
import GridBotParamsView from "./grid-bot/GridBotParamsView";
import TradeParamsView from "./TradeParamsView";
import { BotType } from "../../../Const";
import EntryView from "./modules/EntryView";
import ExitView from "./modules/ExitView";
import AssetViewRent from "../../marketplace/bots/AssetViewRent";
import TradeParamsViewRent from "../../marketplace/bots/TradeParamsViewRent";
import RentExitConditionsView from "../../marketplace/bots/RentExitConditionsView";

const CreateBotStepsRent = (props)=>{
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const rentBot = useSelector((state) => state.createBot.rentBot);
    const isEditing = useSelector((state) => state.createBot.rentBot.isEditing);
    const location = useLocation();
    const initialActiveTab = isEditing && location.state?.activeTab === "exit_conditions" ? 2 : 0;
    const [activeTab,setActiveTab] = useState(initialActiveTab);
    const Exchange = useSelector((state) => state.settings.selectedExchange) || 0;
    const selectedExchange = isEditing?rentBot.exchange:Exchange;
    const tabCount = isEditing ? 3 : 2;
    const stepTitles = isEditing
        ? ['Asset','Trade Parameters','Exit Conditions']
        : ['Asset','Trade Parameters','Create Bot'];
    const changeTab = (type)=>{
        window.scrollTo(0, 0);
        if(type=="next"){
            setActiveTab(Math.min(activeTab+1, tabCount - 1))
        }
        if(type=="prev"){
            setActiveTab(Math.max(activeTab-1, 0))
        }
    }
    const steps = stepTitles.map((item,index)=>{
        return (
            <li key={index}>
                <a onClick={()=>{
                    if(activeTab === 0 && index !== 0 && !rentBot.pair){
                        toast.warn(t("pls-select-stock-symbol"));
                        return;
                    }
                    window.scrollTo(0, 0);
                    setActiveTab(index >= tabCount ? tabCount - 1 : index)
                }} className={`pointer`}>
                    <label className={activeTab>=index || (!isEditing && activeTab >= 1)?'active':'' || (isEditing && activeTab >= 2)?'active':''}><img src={`/images/cb-step-${index}.svg`} alt=""/></label>
                    {item}
                </a>
            </li>
        )
    })
    const tabs = [
        <AssetViewRent rentBot={rentBot} selectedExchange={selectedExchange} t={t} isEditing={isEditing} step={changeTab}/>,
        <TradeParamsViewRent
            editing={isEditing}
            rentBot={rentBot}
            t={t}
            step={changeTab}
        />
        
    ];
    if (isEditing) {
        tabs.push(
            <RentExitConditionsView
                rentBot={rentBot}
                t={t}
                step={changeTab}
            />
        );
    }
    return(
        <>
            <div className={`bot-advance-asset-tab ${isEditing?'editing-rent':''} ba-tab${activeTab} rent`}>
                <ul className="bc-step-icons rent">
                    {steps}
                </ul>
            </div>
            <div className="ba-asset-form-area ec-from">
                {tabs[activeTab]}
            </div>
        </>
      );
}

export default connect(null,{})(CreateBotStepsRent)
